module.exports = __webpack_public_path__ + "static/media/ff_planner.7afb07e6.png";